import { siteUrl } from '@/helpers/seo';
import ac_strings from '@/strings/ac_strings.js';

// Display name of the website itself (ActiveChristianity), used for the
// WebSite node.
export const siteName: string = ac_strings.site_title;

// Stable graph identifier for the Organization node so the WebSite and each
// Article can reference the publisher by @id instead of repeating it.
export const organizationId = `${siteUrl}/#organization`;

/**
 * The publishing entity. ActiveChristianity is the website; it is owned and
 * maintained by Stiftelsen Skjulte Skatters Forlag (Hidden Treasures
 * Foundation), which is therefore the Organization / publisher. Emitted once
 * site-wide; referenced elsewhere by @id.
 */
export const getOrganization = (): { [k: string]: any } => ({
	'@type': 'Organization',
	'@id': organizationId,
	name: 'Hidden Treasures Foundation',
	alternateName: 'Skjulte Skatters Forlag',
	legalName: 'Stiftelsen Skjulte Skatters Forlag',
	url: 'https://www.hiddentreasures.org',
	foundingDate: '1912-01-01',
	founder: {
		'@type': 'Person',
		name: 'Johan Oscar Smith'
	}
});
